import { assertValidBlockXYWH } from '@blocksuite/global/gfx';
import { assertCanvasWorldXYWH } from '@streamlain/canvas-selection-contract';

type XYWHPropValidationContext = {
  blockId?: string;
  flavour?: string;
  path: string;
  value: unknown;
  allowUndefined?: boolean;
  enforceWorld?: boolean;
  previousValue?: unknown;
};

type BlockXYWHPropsValidationContext = {
  blockId?: string;
  flavour?: string;
  props: unknown;
  previousProps?: unknown;
  enforceWorld: boolean;
};

function isValidationObject(value: unknown): value is Record<string, unknown> {
  return (
    value !== null &&
    typeof value === 'object' &&
    Object.prototype.toString.call(value) === '[object Object]' &&
    [Object, undefined, null].some(
      constructor => constructor === value.constructor
    )
  );
}

export function isXYWHPropPath(path: string) {
  return path.split('.').pop() === 'xywh';
}

export function assertValidXYWHPropPath({
  blockId,
  flavour,
  path,
  value,
  allowUndefined = false,
  enforceWorld = true,
  previousValue,
}: XYWHPropValidationContext) {
  if (!isXYWHPropPath(path)) {
    return;
  }

  if (allowUndefined && value === undefined) {
    return;
  }

  assertValidBlockXYWH(value, {
    blockId,
    flavour,
    key: path,
  });
  if (enforceWorld) assertCanvasWorldXYWH(value, previousValue);
}

export function assertValidBlockXYWHProps({
  blockId,
  flavour,
  props,
  previousProps,
  enforceWorld,
}: BlockXYWHPropsValidationContext) {
  const visit = (value: unknown, path: string, previous: unknown) => {
    if (isValidationObject(value)) {
      Object.entries(value).forEach(([key, child]) => {
        visit(
          child,
          path ? `${path}.${key}` : key,
          isValidationObject(previous) ? previous[key] : undefined
        );
      });
      return;
    }

    assertValidXYWHPropPath({
      blockId,
      flavour,
      path,
      value,
      allowUndefined: true,
      enforceWorld,
      previousValue: previous,
    });
  };

  visit(props, '', previousProps);
}
